const eventsRoutes = [
  {
    path: "events",
    name: "Events",
    redirect: {
      name: "Event List"
    },
    component: () =>
      import(/* webpackChunkName: "events" */ "../../views/events/Events.vue"),
    children: [
      {
        path: "list",
        name: "Event List",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/EventsList.vue")
      },
      {
        path: "new",
        name: "New Event",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/NewEvent.vue")
      },
      {
        path: "edit/:id",
        name: "Edit Event",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/NewEvent.vue")
      },
      {
        path: "details/:id",
        name: "Details Event",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/NewEvent.vue")
      },
      {
        path: "selection",
        name: "Guests Selection",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/GuestSelection.vue")
      },
      {
        path: "guests/:id",
        name: "Show Guests",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/GuestList.vue")
      },
      {
        path: "newSurvey/:id",
        name: "New Survey Event",
        component: () =>
          import(/* webpackChunkName: "events" */ "../../views/events/NewSurvey.vue")
      }
    ]
  }
];

export default eventsRoutes;
